export const singleProductUsersCount = ( singleProductData  ) => {

    const shopsRating = singleProductData?.singleProductReview?.opretShopBarSingle

    let userRating

    let ratings = []

    let tmp = []

    shopsRating?.forEach(item => {

        singleProductData?.allShops?.shopLinks?.forEach(shop => {
            if(shop.name === item.vaelgShop) {
                if(shop.affLink !== null){
                  
                    tmp.push({...item, link :  shop.affLink + item.link })

                } 
                if(shop.affLinkEnd !== null){
                   
                    tmp.push({...item, link :  item.link + shop.affLinkEnd })

                }
            }
        })
        
        item.review !== null && ratings.push({ review : item.review, numberReviews : item.numberReviews })

    })
 
    let rating = 0

    let totalRevievs = 0 // the total revievs number from all shops

    ratings.forEach( item => {

        totalRevievs = totalRevievs + item.numberReviews // 

        rating = rating + ( item.numberReviews * item.review )

    })

    if(rating === 0 ){
        
        userRating = 0

    } else {

        userRating = parseFloat( ( rating / totalRevievs ).toFixed(1) )

    }

    return {
        reviewsCount : totalRevievs,
        rating : userRating
    }
}